import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "screen",
  "use": "screen-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"screen\"><g fill-rule=\"nonzero\"><path d=\"M0 3v11h13v-2H2V3zM3 0v2h11v9h2V0z\" /><path d=\"M3 3h10v8H3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id